
<span (click)="toggleSpecialties()" id="toggle">
  <span id="toggle-top" class="toggle-text">
    <span id="toggle-text-wrapper">{{toggleLabel}}
      <span *ngIf="selectedSpecialties.length >= 2 && unselectedSpecialties.length" id="additional" class="toggle-text">
        {{additionalLabel}}</span>
    </span>
    <i class="fa fa-caret-down"></i></span>
</span>
<div id="specialty-dropdown" *ngIf="showSpecialties">
  <div id="list-wrapper">
    <div class="input-search-wrapper">
      <i id="search-glass" class="fa fa-search search-icon" aria-hidden="true"
         [matTooltip]="'3 letters required'" [matTooltipPosition]="'above'"
         [matTooltipDisabled]="searchText.length >= 3" [matTooltipClass]="'custom-tooltip'"></i>
      <input type="text" placeholder="Search..." id="search-for" (input)="onSearchTextChanged()" [(ngModel)]="searchText">
    </div>
    <mat-checkbox (click)="selectAllSpecialties($event)" [checked]="displayedSelectedSpecialties.length &&
      !displayedUnselectedSpecialties.length" id="select-all">Select All</mat-checkbox>
    <div class="specialty-section-heading">Selected Specialties</div>
    <div *ngFor="let specialty of displayedSelectedSpecialties" class="specialty-item"
         (click)="whenSpecialtyClicked(specialty, $event)">
      <mat-checkbox [checked]="true" class="selected-specialty">{{specialty.item.item.specialtyNodeName}}</mat-checkbox>
    </div>
    <div class="specialty-section-heading">Other Specialties</div>
    <div *ngFor="let specialty of displayedUnselectedSpecialties" class="specialty-item"
         (click)="whenSpecialtyClicked(specialty, $event)">
      <mat-checkbox [checked]="false" class="unselected-specialty">{{specialty.item.item.specialtyNodeName}}</mat-checkbox>
    </div>
  </div>
  <div id="buttons-wrapper">
    <button (click)="apply()" id="btn-apply">Apply</button>
    <button (click)="cancel()" id="btn-cancel">Cancel</button>
  </div>
</div>
